import { PriceSummaryRow } from '@ps-design-system/components/PriceSummary';
import { Text } from '@ps-design-system/components/Text';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger
} from '@ps-design-system/components/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const Tooltips = {
  CLEANING_FEE: (
    <FormattedMessage
      id="price_summary.cleaning_fee_tooltip"
      defaultMessage="This covers the cleaning of the space after your booking."
    />
  )
};

export const AddtlChargesLineItems = ({
  addtlCharges,
  currency,
  tooltipAlign = 'center'
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  return (addtlCharges || []).map((charge) => (
    <PriceSummaryRow
      testId="addtl-charges-line-item"
      key={charge.chargeId}
      name={Tooltips[charge.type] ? (
        <Tooltip
          rootProps={{
            delayDuration: 0,
            open: showTooltip,
            onOpenChange: setShowTooltip
          }}
        >
          <TooltipTrigger
            onClick={(e) => {
              e.preventDefault();
              setShowTooltip((prev) => !prev);
            }}
          >
            <Text style={{ textDecoration: 'underline' }}>
              {charge.charge_str}
            </Text>
          </TooltipTrigger>
          <TooltipContent style={{ maxWidth: '248px' }} align={tooltipAlign}>
            <Text typeface="body-1-long">{Tooltips[charge.type]}</Text>
            <TooltipArrow className="tw-fill-base-white" />
          </TooltipContent>
        </Tooltip>
      ) : (
        charge.charge_str
      )}
      value={(
        <FormattedNumber
          value={charge.value || 0}
          style="currency"
          currency={currency}
        />
      )}
    />
  ));
};

AddtlChargesLineItems.displayName = 'AddtlChargesLineItems';
AddtlChargesLineItems.propTypes = {
  addtlCharges: PropTypes.array,
  currency: PropTypes.string,
  tooltipAlign: PropTypes.string
};
